import { useState } from "react";
import ReactLoading from "react-loading";
import styled from "styled-components";
import SpecialLifeAtButton from "@common/LifeAtButton/Variants/SpecialLifeAtButton";
import useStripeSession from "@hooks/useStripeSession";
import { BrowserUtil } from "@util/index";
import SubscriptionTierBlock from "./SubscriptionTierBlock";

const ProBillingPortalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
`;

const BILLING_PORTAL_BUTTON_LABEL = "Manage Subscription";

interface StripeSubscriptionPortalButtonProps {
    readonly isVisible: boolean;
    readonly hideLabel?: boolean;
    readonly overrideButtonText?: string;
}
function StripeSubscriptionPortalButton(props: StripeSubscriptionPortalButtonProps) {
    const [isRedirecting, setIsRedirecting] = useState(false);
    const { getBillingPortalUrl } = useStripeSession();

    const handleClick = async () => {
        setIsRedirecting(true);
        const sessionUrl = await getBillingPortalUrl();
        BrowserUtil.redirectTo(sessionUrl);
    };

    let billingButton = null;
    if (!isRedirecting) {
        billingButton = (
            <SpecialLifeAtButton
                isLink={false}
                text={props.overrideButtonText ?? BILLING_PORTAL_BUTTON_LABEL}
                handleClick={handleClick}
                variant={"blue"}
                shape={"pill"}
            />
        );
    } else if (isRedirecting) {
        billingButton = <ReactLoading type={"spokes"} color={"#E39685"} height={25} width={25} />;
    }

    return props.isVisible ? (
        <ProBillingPortalWrapper>
            <SubscriptionTierBlock isVisible={true} buttonComponent={billingButton} hideLabel={props.hideLabel} />
        </ProBillingPortalWrapper>
    ) : null;
}

export default StripeSubscriptionPortalButton;
